import { SET_APOLLO_CLIENT } from './constants'
import { ApolloClientType } from './types'

export const setApolloClient = (client: ApolloClientType) => ({
    type: SET_APOLLO_CLIENT,
    client,
})
